import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const CookiePolicyPage = () => (
  <PublicLegalContentPage
    slug="cookies"
    seoTitle="Cookie Policy | Pleerity Enterprise Ltd"
    seoDescription="Learn about how Pleerity Enterprise Ltd uses cookies and similar technologies."
    canonicalUrl="/legal/cookies"
  />
);

export default CookiePolicyPage;
